<template>
    <section :class="css.container" class="container" ref="container">
        <!-- * 描述信息（不管是否存在译文, 仅存在原文展示） -->
        <div :class="css.info">
            <div class="text-hint" v-if="!origin.descript.origin">{{ $t("Placeholder.NotModuleDescript") }}</div>
            <template v-else>
                <div>{{ origin.descript.default }}</div>
                <AIStatement :class="css.statement" :name="$t('BasicInformation')" subject="shallow" :contexts="origin.descript" type="Gene" />
            </template>
        </div>

        <!-- * 相关信息 -->
        <div :class="css.ids">
            <div class="font-bold color-1">{{ $t("RelatedID") }}：</div>
            <div :class="css.content">
                <template v-if="!origin?.related_ids?.length">{{ $t("NoDataAvailable") }}</template>
                <template v-else>
                    <div :class="css.id" v-for="(related, key) in origin.related_ids" :key="key">
                        <template v-if="related.href">
                            <project-route :class="css_normalize.assets" :to="related.href">{{ related.name }}：{{ related.id }}</project-route>
                        </template>
                        <template v-else>
                            <div>{{ related.name }}：{{ related.id }}</div>
                        </template>
                    </div>
                </template>
            </div>
        </div>

        <!-- * 基本信息 -->
        <div :class="css.body">
            <!-- * 标题 -->
            <div :class="css.name" class="font-bold font-variable color-1">{{ $t("BasicInformation") }}</div>
            <!-- * 表格 -->
            <ui-table2 :class="css.table" :option="options.info" :data="[origin.info]">
                <template #methods="{ data }">
                    <template v-if="!data.methods.length">--</template>
                    <ui-tooltip v-else :class="css.method" direction="bottom" align="center" v-for="value in data.methods" :content="value.content">
                        <div>{{ value.name }}</div>
                    </ui-tooltip>
                </template>

                <template #prevalence="{ data }">
                    <template v-if="!data.prevalence">--</template>
                    <template v-else>
                        <span>{{ data.prevalence }}</span>
                        <template v-if="data.prevalence_data.length">
                            <ui-tooltip :class="css.visible" :class-extra-name="css.view" ref="tooltip" v-on="ons.visible" v-bind="binds.visible">
                                <ui-icon :name="visible ? 'subtract' : 'add'" @click="methods.hidden" />
                                <template #content>
                                    <div :class="css.module" v-for="value in data.prevalence_data">
                                        <div :class="css.title" class="font-bold color-1">{{ value.name }}:</div>
                                        <div :class="css.item" v-for="item in value.data">
                                            <span style="color: var(--uicolor-main-color)">{{ item.title }}&nbsp;</span>({{ item.content }})
                                        </div>
                                    </div>
                                </template>
                            </ui-tooltip>
                        </template>
                    </template>
                </template>

                <template #genes="{ data }">
                    <template v-if="!data.genes">--</template>
                    <template v-else>
                        <div :class="css_normalize.assets" @click="$emit('move3')">{{ data.genes }}</div>
                    </template>
                </template>

                <template #models="{ data }">
                    <template v-if="!data.models">--</template>
                    <template v-else>
                        <div :class="css_normalize.assets" @click="$emit('move5')">{{ data.models }}</div>
                    </template>
                </template>
                <template #orthologs> -- </template>
                <template #references="{ data }">
                    <template v-if="!data.references">--</template>
                    <template v-else>
                        <div :class="css_normalize.assets" @click="$emit('move6')">{{ data.references }}</div>
                    </template>
                </template>

                <template #malacard="{ data }">
                    <template v-if="!data.malacard">--</template>
                    <template v-else>
                        <ProjectRoute :class="css_normalize.assets" :to="data.malacard">
                            {{ $route.params.id }}
                        </ProjectRoute>
                    </template>
                </template>
            </ui-table2>
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库引入
import { UiIcon, UiTooltip, UiTable2 } from "various-ui";
//* 公共组件引入
import { AIStatement } from "@/components/controls";
//* 组件属性
import { ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组件属性注册
defineProps(ModulePropsOption);

//* 组合函数
const { ons, refs, nodes, binds, methods, options } = useComposable();
const { visible } = refs;
const { container, tooltip } = nodes;
</script>
